import * as React from 'react';
import { notifySuccess } from '@gandi/notifications';
import CheckoutButton from '../CheckoutButton';
import { getTitleLabel, getDescriptionLabel } from '../DrawerContent/Body/helpers';
import LongWordBreaker from '../LongWordBreaker';
import ViewCartButton from '../ViewCartButton';
import { NOTIFICATION_ID } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_BUTTONS = [/*#__PURE__*/_jsx(CheckoutButton, {
  small: true,
  marginRight: "xsmall"
}), /*#__PURE__*/_jsx(ViewCartButton, {
  small: true,
  kind: "outline"
})];
export const notifyAddedToCart = ({
  translator: {
    __
  },
  message,
  buttons
}) => dispatch => dispatch(notifySuccess({
  id: NOTIFICATION_ID,
  title: __('Added to cart'),
  message,
  buttons: buttons || DEFAULT_BUTTONS
}));
export const notifyOneProductAdded = ({
  translator,
  product,
  buttons
}) => dispatch => {
  const {
    prices,
    product_type,
    process,
    quantity,
    identifier,
    label
  } = product;
  const message = `${getTitleLabel({
    translator,
    productType: product_type,
    process,
    payload: product.payload || {}
  })} - ${getDescriptionLabel({
    translator,
    productType: product_type,
    process,
    payload: product.payload || {},
    quantity,
    identifier,
    label,
    prices
  })}`;
  const userTextShown = ['domain', 'tmch'].includes(product_type) || product_type === 'cloud' && product.payload?.isFirstServer;
  dispatch(notifyAddedToCart({
    translator,
    message: userTextShown ? /*#__PURE__*/_jsx(LongWordBreaker, {
      children: message
    }) : message,
    buttons
  }));
};
export const notifyBundleAdded = ({
  translator,
  translator: {
    __
  },
  buttons
}) => dispatch => {
  dispatch(notifyAddedToCart({
    translator,
    message: __('Domain bundle'),
    buttons
  }));
};
export const notifyProductCountAdded = ({
  translator,
  translator: {
    __
  },
  count,
  buttons
}) => dispatch => {
  dispatch(notifyAddedToCart({
    translator,
    message: __('%(count)s items', {
      count
    }),
    buttons
  }));
};
export const notifyManyProductsAdded = ({
  translator,
  successes,
  buttons
}) => dispatch => {
  if (successes.length === 0) {
    return;
  }
  if (successes.length === 1 && successes[0].productData) {
    dispatch(notifyOneProductAdded({
      translator,
      product: successes[0].productData,
      buttons
    }));
  } else if (successes.every(s => s.productData.product_type === 'mailboxv2')) {
    const condensedProduct = {
      ...successes[0].productData,
      quantity: successes.length
    };
    if (successes.every(s => s.productData.payload?.mailbox_type === 'standard') || successes.every(s => s.productData.payload?.mailbox_type === 'premium')) {
      dispatch(notifyOneProductAdded({
        translator,
        product: condensedProduct,
        buttons
      }));
    } else {
      delete condensedProduct.payload.mailbox_type;
      dispatch(notifyOneProductAdded({
        translator,
        product: condensedProduct,
        buttons
      }));
    }
  } else {
    dispatch(notifyProductCountAdded({
      translator,
      count: successes.length,
      buttons
    }));
  }
};